import { render, staticRenderFns } from "./InitLoader.vue?vue&type=template&id=c5080222&scoped=true&"
import script from "./InitLoader.vue?vue&type=script&lang=ts&"
export * from "./InitLoader.vue?vue&type=script&lang=ts&"
import style0 from "./InitLoader.vue?vue&type=style&index=0&id=c5080222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5080222",
  null
  
)

export default component.exports